"use client";
import { Box } from "@mui/material";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material/styles";
import { ColorWhite, SpaceMd, FontSize400, FontWeightDefault, ColorTextDefault, FontSize500, SpaceXs, ColorTextLink } from "@nxt-costco-com/forge-design-tokens";
import { XThin, ChevronUp, ChevronDown } from "@nxt-costco-com/forge-icons";
import { Text } from "../../DataDisplay/Text/index.js";
import { Button } from "../../Inputs/Button/index.js";
import { PopupPositionRight, PopupPositionLeft } from "./types.js";
const PopupWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "popupPosition" && prop !== "strategy"
})(
  ({ popupPosition = PopupPositionRight, strategy }) => `
    pointer-events: none;
    position: ${strategy};
    z-index: 1000;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    transition: height 500ms;
    display: flex;
    flex-direction: row;
    justify-content: ${popupPosition === PopupPositionRight ? "flex-end" : popupPosition === PopupPositionLeft ? "flex-start" : "center"};
`
);
const StyledSlide = styled(Slide)`
    pointer-events: auto;
    boxshadow: -2px -2px 8px rgba(0, 0, 0, 0.25);
`;
const StyledPopup = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOpenView"
})(
  ({ isOpenView = false }) => `
    pointer-events: auto;
    min-width: 498px;
    height: auto;
    border-radius: 0px;
    background-color: ${ColorWhite};
    padding: ${SpaceMd};
    display: flex;
    gap: ${isOpenView ? SpaceMd : "0px"};
    flex-direction: column;
    word-break: break-word;
    position: absolute;
    bottom: 0;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.20);
`
);
const TitleWrapper = styled(Box)`
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: ${SpaceMd};
`;
const TitleContainer = styled(Box)`
    width: 100%;
`;
const StyledTitleText = styled(Text)(
  ({ theme }) => ({
    fontSize: FontSize500,
    fontColor: ColorTextDefault,
    fontWeight: FontWeightDefault,
    lineHeight: 1,
    [theme.breakpoints.down("lg")]: {
      fontSize: FontSize400,
      lineHeight: 1.3
    }
  })
);
const ButtonWrapper = styled(Box)`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 24px;
`;
const ShowHideButton = styled(Button)`
    width: 100%;
    height: 100%;
    padding: 0px;
    background: none;
    background-color: none;
    display: flex;
    gap: ${SpaceXs};

    &:hover {
        background: none;
        background-color: none;
    }

    &:active {
        background: none;
        background-color: none;
    }

    &:visited {
        background: none;
        background-color: none;
    }

    &:focus {
        background: none;
        background-color: none;
    }
`;
const StyledShowHideText = styled(Text)`
    color: ${ColorTextLink};
    width: max-content;
`;
const StyledXThin = styled(XThin)`
    height: 20px;
    width: 20px;
    color: ${ColorTextDefault};
`;
const StyledChevronUp = styled(ChevronUp)`
    height: 20px;
    width: 20px;
    color: ${ColorTextLink};
`;
const StyledChevronDown = styled(ChevronDown)`
    height: 20px;
    width: 20px;
    color: ${ColorTextLink};
`;
export {
  ButtonWrapper,
  PopupWrapper,
  ShowHideButton,
  StyledChevronDown,
  StyledChevronUp,
  StyledPopup,
  StyledShowHideText,
  StyledSlide,
  StyledTitleText,
  StyledXThin,
  TitleContainer,
  TitleWrapper
};
